import { Link } from 'react-router-dom';
import {
  FolderIcon,
  RectangleStackIcon,
  AcademicCapIcon,
  ChartBarIcon,
  BuildingOffice2Icon,
  CalendarDaysIcon,
  ClipboardDocumentListIcon,
  BriefcaseIcon,
} from '@heroicons/react/24/outline';

interface AdminPanelProps {
  className?: string;
}

export default function AdminPanel({ className = '' }: AdminPanelProps) {
  const adminLinks = [
    {
      title: 'Programs and references',
      description: 'Create a program or reference and assign toolkits',
      icon: RectangleStackIcon,
      link: '/admin/programs',
      color: 'text-blue-700',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'Toolkits',
      description: 'Create and manage toolkits',
      icon: FolderIcon,
      link: '/admin/hubs',
      color: 'text-blue-700',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'Careers',
      description: 'Post openings with external apply links',
      icon: BriefcaseIcon,
      link: '/admin/careers',
      color: 'text-blue-700',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'Resource orders',
      description: 'View printed resource orders',
      icon: ClipboardDocumentListIcon,
      link: '/admin/orders',
      color: 'text-blue-700',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'Manage Events',
      description: 'Create and publish events',
      icon: CalendarDaysIcon,
      link: '/admin/events',
      color: 'text-blue-700',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'Hospital domains',
      description: 'Manage sites, domain types, and OHP access',
      icon: BuildingOffice2Icon,
      link: '/admin/hospital-domains',
      color: 'text-blue-700',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'eLearning Courses',
      description: 'Build and manage courses',
      icon: AcademicCapIcon,
      link: '/elearning/admin/courses',
      color: 'text-indigo-700',
      bgColor: 'bg-indigo-50',
    },
    {
      title: 'Analytics',
      description: 'View site analytics',
      icon: ChartBarIcon,
      link: '/admin/analytics',
      color: 'text-purple-700',
      bgColor: 'bg-purple-50',
    },
  ];

  return (
    <div className={className}>
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Admin Access</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {adminLinks.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.link}
              to={item.link}
              className={`${item.bgColor} ${item.color} p-6 rounded-lg border border-transparent hover:border-gray-300 transition-all hover:shadow-md group`}
            >
              <div className="flex items-start gap-4">
                <div className={`${item.bgColor} ${item.color} p-3 rounded-lg group-hover:scale-110 transition-transform`}>
                  <Icon className="h-6 w-6" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {item.description}
                  </p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
